import React from "react";
import { Link } from "react-router-dom";
import backimg from '../../../assets/solutions-images/hero_ban_customer_service.webp';
import "../solution.css"
const CustomerService = () => {
    return (
        <>
            <div>
                <div
                    className="bg-cover bg-center bg-no-repeat min-h-[502px] flex flex-col gap-8 justify-center px-6 py-16 md:px-8 lg:px-16 hover_herosec"
                    style={{ backgroundImage: `url(${backimg})` }}
                >
                    <h1 style={{ wordSpacing: '8px' }} data-aos="fade-down" className="text-xl md:text-3xl lg:text-5xl font-semibold text-white max-w-[680px]">
                        Create Powerful Customer Service Experiences
                    </h1>
                    <p className="text-white text-sm max-w-[630px]" data-aos="fade-down">
                        Partner with Tekpossible to maximize the potential of your ServiceNow CSM features. Our expertise helps you effectively manage customer interactions, streamline service workflows, and drive continuous improvement.
                    </p>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="300"
                        to="/contact-us"
                        className="w-[100px] w-fit sm:w-[150px] md:w-[140px] text-semibold lg:w-[150px] bg-[#C32A7C] px-5 py-2 sm:px-6 sm:py-2.5 lg:px-7 lg:py-2 rounded-lg text-white  hover:bg-white hover:text-[#C32A7C] transition-colors duration-400 ease-in-out text-sm sm:text-sm md:text-sm lg:text-lg text-center whitespace-nowrap"
                    >
                        Contact Us
                    </Link>

                </div>
            </div>
            <div className="bg-[#FFFFFF] mt-6">

                <div className="flex flex-col sm:justify-center text-center items-center gap-4 py-8 px-4">
                    <h1 className="text-[#1A5298] font-bold text-lg md:text-3xl">
                        What can we help you achieve with CSM solutions by ServiceNow?
                    </h1>
                </div>

                <div className="bg-white mb-20">
                    <div data-aos="zoom-in-down" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-10 px-4 md:px-10 lg:px-10 py-5 items-start">
                        <div className="flex flex-col items-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-base lg:text-[15px] xl:text-xl font-semibold max-w-[250px] text-center">Optimize Customer Self-Service</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40 ">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-center max-w-[350px]">
                                Offer customers a complete support ecosystem, including personalized self-service, community engagement, and rapid issue resolution.
                            </p>
                        </div>
                        <div className="flex flex-col items-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-base lg:text-[15px] xl:text-xl font-semibold max-w-[253px] text-center">Adapt to Customer Preferences</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40 ">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-center max-w-[450px]">
                                Give customers the freedom to connect on their terms, while equipping agents with the insights they need for seamless, cross-channel conversations and a complete view of customer activity.
                            </p>
                        </div>
                        <div className="flex flex-col items-center justify-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-base lg:text-[15px] xl:text-xl font-semibold max-w-[253px] text-center">Enhance Customer Satisfaction</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40 ">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-center max-w-[350px]">
                                Proactively manage product and service health to minimize support requests and enhance customer transparency
                            </p>
                        </div>
                    </div>
                </div>
            </div>



            <div className="bg-[#F4F4F4] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6" data-aos="zoom-in-down">

                    <h1 className="text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-5 w-full">
                        Our ServiceNow CSM Expertise
                    </h1>
                    <h5 className="text-md text-black font-medium text-center max-w-[800px]">Communities | Customer Case Tracking | Customer Records Management Enterprise Data Model | Omni-Channel | Predictive Customer Support Processes</h5>

                </div>
            </div>
            <div className="bg-[#FFFFFF] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6">

                    <h1 data-aos="zoom-in-down" className="line_heightsests text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-8 max-w-[800px]">
                        Ready to transform your customer service with ServiceNow CSM?
                    </h1>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="200"
                        to={"/contact-us"}
                        className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-semibold 
                        hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base 
                        text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
                    >
                        Contact Us
                    </Link>

                </div>
            </div>
        </>
    );
}

export default CustomerService;